const BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    },
    body: options.body instanceof FormData ? options.body : options.body ? JSON.stringify(options.body) : undefined,
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `Request failed (${res.status})`);
  }

  return res.json();
}

export const api = {
  // Auth
  login: (email, password) => request('/auth/login', { method: 'POST', body: { email, password } }),
  logout: () => request('/auth/logout', { method: 'POST' }),
  me: () => request('/auth/me'),

  // Tickets
  getTickets: () => request('/tickets'),
  getTicket: (id) => request(`/tickets/${id}`),
  createTicket: (formData) => request('/tickets', { method: 'POST', body: formData }),
  updateTicket: (id, data) => request(`/tickets/${id}`, { method: 'PATCH', body: data }),
  toggleStar: (id) => request(`/tickets/${id}/star`, { method: 'POST' }),
  addUpdate: (ticketId, formData) => request(`/tickets/${ticketId}/updates`, { method: 'POST', body: formData }),
  getAuditLog: (ticketId) => request(`/tickets/${ticketId}/audit`),
  editUpdate: (ticketId, updateId, data) => request(`/tickets/${ticketId}/updates/${updateId}`, { method: 'PATCH', body: data instanceof FormData ? data : data }),
  deleteUpdate: (ticketId, updateId) => request(`/tickets/${ticketId}/updates/${updateId}`, { method: 'DELETE' }),
  moderateAttachment: (ticketId, attachmentId, approved) =>
    request(`/tickets/${ticketId}/attachments/${attachmentId}`, { method: 'PATCH', body: { approved } }),
  getSpamAttachmentSummary: () => request('/tickets/spam/attachments/summary'),
  purgeSpamAttachments: () => request('/tickets/spam/attachments/purge', { method: 'POST' }),

  // Trustees
  getTrustees: () => request('/trustees'),
  updateProfile: (data) => request('/trustees/me', { method: 'PATCH', body: data }),
  createTrustee: (data) => request('/trustees', { method: 'POST', body: data }),
  editTrustee: (id, data) => request(`/trustees/${id}`, { method: 'PATCH', body: data }),
  resetTrusteePassword: (id, password) => request(`/trustees/${id}/reset-password`, { method: 'POST', body: { password } }),
  deleteTrustee: (id) => request(`/trustees/${id}`, { method: 'DELETE' }),
};
